'use strict';

import {getUrlParam} from "./functions";
import {ViewMode} from "./common";
import gsap from "gsap";
import { District } from './modules/building/District';
import { GSAPMixers } from './modules/threejs/GSAPMixer';
import { Vector2 } from 'three';
import {BmbyMode} from "./modules/mode/BmbyMode";

const MobileDetect = require('mobile-detect');
export const assignDeep = require('object-assign-deep');

export const isMobile = Boolean(new MobileDetect(window.navigator.userAgent).mobile() && !new MobileDetect(window.navigator.userAgent).tablet()) || parseInt(getUrlParam('mobile')) === 1;
export const isTablet = Boolean(new MobileDetect(window.navigator.userAgent).mobile() && new MobileDetect(window.navigator.userAgent).tablet())
    || /Macintosh/.test(window.navigator.userAgent) && 'ontouchend' in document;
export const isIOS = navigator.vendor && navigator.vendor.indexOf('Apple') > -1;
export const isSafari =
  isIOS &&
  navigator.userAgent &&
  navigator.userAgent.indexOf('CriOS') === -1 &&
  navigator.userAgent.indexOf('FxiOS') === -1;
export const isDesktop = !isMobile && parseInt(getUrlParam('desktop')) === 1;
export const isWeb = !isMobile && !isDesktop && !isTablet;
export const isNoMenu = getUrlParam('nomenu');
export const isPWA = getUrlParam('source') === 'pwa';
export const AVAILABLE_STATUS = (BmbyMode.active) ? 'For Sale' : 'Available';

if (isMobile && !isTablet) {
    document.body.classList.add('mobile-mode');
} else if (isDesktop) {
    document.body.classList.add('desktop-mode');
}

export const isDev =
  getUrlParam('dev') === 'true' ||
  getUrlParam('dev') === '1';

export const UIRoot = document.getElementById('ui');
export const TRoot = document.getElementById('threejs');

export const threeJsVariables = {
    scene: {},
    raycaster: {},
    animator: null,
    mouse: new Vector2(),
    gyroscope: new Vector2(),
    perspectiveCamera: {},
    cameraTarget: {},
    renderer: {},
    stats: null,
    labelRenderer: null,
    tooltipRenderer: null,
    tilesRenderer: null,
    directionLightCylinder: null,
    composer: null,
    time: null,
    gui: null,
    cloth: null,
    canvasResize: true
}

export const components = {};

export const settingsData = {
    fps: config.threejs.optimization ? config.threejs.optimization.fps : 20,
    resolveTilesUpdate: true,
    loadingError: false,
    slideShowed: false,
    isSound: false,
    projectLoaded: false,
    postProcessing: { //Post-Processing settings
        isActive: false,
        effectFXAA: false,
        depthOfFields: false,
        depthOfFields2: false,
        ambientOcclusion: false,
    },
    stopTimeRender: 5 * 60 * 1000, //time after which the render will stop 5 minutes
    desktopGallery:{
        columnCount: config.features?.gallery?.columnCount || 3,
        gutter: config.features?.gallery?.gutter || 10
    },
    activeViewMode: ViewMode.Orbit,
    calculatePoints: false,
    widgetsPaddingTop: 72,
    destroyedMode: false,
    selectedObject: null,
    hoveredObject: null,
    bombBlock: false,
    userPrevent: false,
    globalThrottle: false,
    animationsDuration: 0.3,
    animationsList:[],
    searchState: [],
    dictionary: null,
    tourOrbitMode: false,
    zoomButtonsStep: {
        increase: 0.02,
        decrease: -0.02
    },
    globalSettings: {
        doubleClickToUnavailable: false,
        flat_focus: false,
        totalDollyBounce: 1,
        floorAppearAnimation: {
            durationBase: 700,
            addPosition: 1000,
            axis: 'y',
        }
    },
    showApplyNow: true,
    lastClickedFlat: '',
    stopRender: false,
    blockRenderState: false,
    target_zoom: '',
    isIntersection: false,
    buildingDestroyed: false,
    last_interaction: Date.now(),
    totalPercent: 0,
    customSelections: [],
    instanced_floors: [],
    instanced_floors_switch: {},
    currentFloor: 0,
    floor_obj: {},
    lastHoverObject: '',
    objectToDisappear: [],
    isSwitched: false,
    tween_animations: {},
    current_mouse_position: {x : 0, y : 0},
    box_to_intersection: [],
    objects_to_intersection: [],
    additionalIntersectionObjects: [],
    poiIntersection: [],
    floor_plan_btn_last_click: Date.now(),
    headerObjectState:{
        lastSize: 0,
        lastSizeWhenMobileMenuActivated: 0,
    },
    groundFloor: {
      isActive: !(config.features?.groundFloor === false && (config.features?.groundFloor !== 0)),
      floor: config.features?.groundFloor || 0,
      fullLabel: 'floorFullName',
      shortLabel: 'floorShortName'
    },
    doubleClick: false,
    sceneBgContent:{
        orbit:{},
        cylinder:{}
    },
    isLandscape: undefined,
    switchLang: false,
    isConferenceHost: config.features.conference || window.location.host.match(/confdreams.bmby.com/gi) || window.location.host.match(/dreams360.bmby.com/gi) || window.location.host.match(/dreams360lite.bmby.com/gi),
    // isConferenceHost: true,
    isFlat: false,
    tl: gsap.timeline(),
    isTouchEvent: false,
    isClickEvent: false,
    stopWindowResizeEvents: false,
    totalTilesCount: 0,
    customCursor: false,
    animateBuildingHover: false,
    activeModeSwitching: false,
    statisticData: {},
    selectionBoxesDefaultColors: [
        {
            status: 'insaving',
            basic: "81379e",
            hover: "b472cf",
            active: "b90dff",
            isActive: true,
            opacity: {
                basic: 0.3,
                hover: 0.8
            }
        }
    ],
    specifications: null
};

export const Buildings = new District();
export const GSAPAnimationMixer = new GSAPMixers();
export const resourcesFolder = config?.resourcesFolder || 'resources';

export const cardsData = {
    cardMode: {
        isUnavailable: false,
        isAmenities: false
    },
    openedCards: [],
    multiplyCards: false,
};


export const projectMode = {
    Orbit: null,
    AirMode: null,
    Cylinder: null,
    FloorPlan: null,
    LiteMode: null,
    Pagination: null,
    QA: null
};

export const globalTextures = {};


// window.bi = buildings_info;
window.animation = GSAPAnimationMixer;
window.b = Buildings;
window.v = threeJsVariables;
window.s = settingsData;
window.c = config;
window.ct = threeJsVariables.cameraTarget;
window.cd = cardsData;
window.pm = projectMode;
window.gt = globalTextures;
